import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";

const initialState = {
  isLoading: false,
};
export const slice = createSlice({
  name: "loadingStatus",
  initialState: _.cloneDeep(initialState),
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
  },
});

export const { setLoading } = slice.actions;

export default slice.reducer;
